var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-table',{attrs:{"striped":"","hover":"","selectable":"","select-mode":"single","items":_vm.users,"fields":_vm.fields,"per-page":_vm.perPage,"current-page":_vm.currentPage}}),_c('TablePagination',{attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage},on:{"pageChange":_vm.onPageChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }